module.exports = __webpack_public_path__ + "static/media/service.51378d47.svg";